import { render, staticRenderFns } from "./scene19.vue?vue&type=template&id=1a228b70&scoped=true&"
import script from "./scene19.vue?vue&type=script&lang=ts&"
export * from "./scene19.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a228b70",
  null
  
)

export default component.exports